import { render, staticRenderFns } from "./BA_Services.vue?vue&type=template&id=78875b70&"
import script from "./BA_Services.vue?vue&type=script&lang=js&"
export * from "./BA_Services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports